import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { useCallback, useEffect, useState } from "react";
import { db } from "../firebase/firebase";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { formatFirestoreDate } from "views/Dashboard";
import { formatISODate } from "views/Dashboard";
import { categoryOrderWithIds } from "views/Test";

const UseChartData = () => {
  const [chartData, setChartData] = useState(null);
  const [categoriesData, setCategoriesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [testData, setTestData] = useState([]);
  const [testDates, setTestDates] = useState([]);
  const [date, setDate] = useState(null);
  const [date2, setDate2] = useState(null);
  const [userId, setUserId] = useState(null);
  const [LeaderShip, setLeaderShip] = useState(null);
  const [testInfos, setTestInfos] = useState([]);
  
  const location = useLocation();
  const userIdStorage = localStorage.getItem("userIdStorage");
  const roleFromStorage = localStorage.getItem("role");

  const LeaderShipAujourdhui = [
    "Leader",
    "Qualités",
    "Efforts",
    "Potentiel",
    "Satisfaction",
    "Développement",
  ];

  useEffect(() => {
    if (roleFromStorage === "candidate") {
      setUserId(userIdStorage);
    }
  }, [roleFromStorage]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const idUser = params.get("userId");
    if (idUser) {
      setUserId(idUser);
    }
  }, [location]);

  const Valeurs = [
    "Indépendance",
    "Challenge",
    "Créativité",
    "Instruction",
    "Plaisir",
    "Responsabil.",
    "Coopération",
    "Accompliss.",
    "Reconnaiss.",
    "Réputation",
    "Courage",
    "Tranquillité",
  ];

  const EtatEsprit = [
    "Passion",
    "Action",
    "Objectifs",
    "Risque",
    "Réussite",
    "Complexité",
    "Impact",
    "Décision",
    "Discipline",
  ];

  const Communication = [
    "Orale",
    "Écoute",
    "Préparation",
    "Compréhension",
    "Détails",
    "Feedback",
    "Ressenti",
    "Ecrit",
    "Efficacité",
  ];

  const confiance = [
    "Exprimer",
    "Démontrer",
    "Informer",
    "Déléguer",
    "Limites",
    "Walk the Talk",
    "Admettre",
    "Appliquer",
    "Confiance",
  ];

  const conflit = [
    "Confronté",
    "Humour",
    "Optimisme",
    "Opportunité",
    "Rôle",
    "Innovant",
    "Emotions",
    "Constructif",
    "Vengeance",
    "Solutions",
  ];

  const resilience = [
    "Atouts",
    "Défis",
    "Authenticité",
    "Stress",
    "Adaptabilité",
    "Rebondir",
    "Cohérence",
    "Collaboration",
    "Soins",
    "Soutien",
  ];

  const vousmeme = [
    "Physique",
    "Mental",
    "Spirituel",
    "Soi",
    "Paix",
    "Epanouiss.",
    "Anxiété",
    "Image",
    "Négativité",
    "Adversité",
    "Ruminer",
    "Alignement",
    "Choix",
    "Vie Privée",
    "Complétude",
    "Technologies",
  ];

  const futur = [
    "Volonté",
    "Vision",
    "Point de vue",
    "Ambiguité",
    "Curiosité",
    "Contributon",
    "Amélioration",
    "Incertitude",
  ];

  /* 
  
  futur old
  
   "Mgt-Ambig",
    "Curiosité",
    "Contribuer",
    "Amélior-Pratq",
    "Incertitude",
    */
  const labels = [
    ...LeaderShipAujourdhui,
    ...Valeurs,
    ...EtatEsprit,
    ...Communication,
    ...confiance,
    ...conflit,
    ...resilience,
    ...vousmeme,
    ...futur,
  ];

  const categoryIds = [
    "4jx2EMzabASVxfbKBKxQ",
    "Kn1O3C6oUTXlgyWn5utY",
    "M1zQrDhFj0LYbyYVCs1H",
    "u18ckyczskXpvLmQ9wCV",
    "yz0kVA4XJ1Ivd1eFmIHZ",
    "rYbeaMIQuKar27QYsXVG",
    "yyZWreYDX93rPRnjIkwh",
    "wClgeAd1l2hqzfw5l4aV",
    "PC6KaYF98rIsfNwH2FTC",
  ];

  // Fonction pour récupérer les dates des tests de l'utilisateur
  const getUserTestDates = async (userId) => {
    try {
      const userTestsRef = collection(db, "UserTests");
      const q = query(userTestsRef, where("userId", "==", userId));
      const querySnapshot = await getDocs(q);
      const dates = querySnapshot.docs.map((doc) => doc.data().testDate);
      const sortedDates = dates.sort((a, b) => new Date(a) - new Date(b));
      const testInfosData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        date: doc.data().testDate,
        testId: doc.data().testId,
      }));
      setTestInfos(testInfosData);

      setDate(sortedDates?.[0]);
      setTestDates(sortedDates);
    } catch (error) {
      console.error("Error fetching UserTest dates: ", error);
    }
  };

  const getUserLastTests = async (userId, filterDate = null) => {
    try {
      const userTestsRef = collection(db, "UserTests");
      let q = null;
      if (roleFromStorage === "candidate" || roleFromStorage === "referent") {
        if (testDates?.[testDates?.length - 1]) {
          q = query(
            userTestsRef,
            where("userId", "==", userId),
            where("testDate", "==", testDates?.[testDates?.length - 1]),
            where("sharedState", "==", true),
            where("shareTypes", "array-contains", roleFromStorage)
          );
        } else {
          q = query(
            userTestsRef,
            where("userId", "==", userId),
            where("sharedState", "==", true),
            where("shareTypes", "array-contains", roleFromStorage)
          );
        }
      } else {
        if (testDates?.[testDates?.length - 1]) {
          q = query(
            userTestsRef,
            where("userId", "==", userId),
            where("testDate", "==", testDates?.[testDates?.length - 1])
          );
        } else {
          q = query(userTestsRef, where("userId", "==", userId));
        }
      }

      const querySnapshot = await getDocs(q);
      const userTests = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      if (userTests?.length === 0) {
        return [];
      }

      /*  setTestData(userTests); */
      return userTests;
    } catch (error) {
      console.error("Error fetching UserTests: ", error);
      return [];
    }
  };
  const getUserTestsByUserId = async (userId, filterDate = null) => {
    try {
      const userTestsRef = collection(db, "UserTests");
      let q = null;
      if (roleFromStorage === "candidate" || roleFromStorage === "referent") {
        if (date && date2) {
          q = query(
            userTestsRef,
            where("userId", "==", userId),
            where("testDate", "in", [date, date2]),
            where("sharedState", "==", true),
            where("shareTypes", "array-contains", roleFromStorage)
          );
        } else if (date) {
          q = query(
            userTestsRef,
            where("userId", "==", userId),
            where("testDate", "==", date),
            where("sharedState", "==", true),
            where("shareTypes", "array-contains", roleFromStorage)
          );
        } else {
          q = query(
            userTestsRef,
            where("userId", "==", userId),
            where("sharedState", "==", true),
            where("shareTypes", "array-contains", roleFromStorage)
          );
        }
      } else {
        if (date) {
          q = query(
            userTestsRef,
            where("userId", "==", userId),
            where("testDate", "in", (date && date2 ? [date, date2] : [date]))
          );
        } else {
          q = query(userTestsRef, where("userId", "==", userId));
        }
      }

      const querySnapshot = await getDocs(q);
      const userTests = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      if (userTests?.length === 0) {
        return [];
      }

      setTestData(userTests);
      return userTests;
    } catch (error) {
      console.error("Error fetching UserTests: ", error);
      return [];
    }
  };

  const getCategoriesByTestId = async (testId) => {
    try {
      const testDocRef = doc(db, "Tests", testId);
      const testDoc = await getDoc(testDocRef);
      if (testDoc.exists()) {
        const testData = testDoc.data();
        return testData.categories;
      } else {
        console.log(`Test with ID ${testId} not found`);
        return [];
      }
    } catch (error) {
      console.error("Error fetching test categories: ", error);
      return [];
    }
  };

  const getUserTestsAndCategories = async (userId) => {
    try {
      setLoading(true);
      const userTests = await getUserTestsByUserId(userId);
      const testsWithCategories = await Promise.all(
        userTests.map(async (userTest) => {
          const categories = await getCategoriesByTestId(userTest.testId);
          return {
            ...userTest,
            categories,
          };
        })
      );
      setLoading(false);
      return testsWithCategories;
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const getUserLastTestsAndCategories = async (userId) => {
    try {
      setLoading(true);
      const userLastTests = await getUserLastTests(userId);
      const testsWithCategories = await Promise.all(
        userLastTests.map(async (userTest) => {
          const categories = await getCategoriesByTestId(userTest.testId);
          return {
            ...userTest,
            categories,
          };
        })
      );
      setLoading(false);
      return testsWithCategories;
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  function extraireAnnee(dateStr) {
    // Créer un objet Date à partir de la chaîne de caractères
    const dateObj = new Date(dateStr);
    // Extraire et retourner l'année
    return dateObj.getFullYear();
  }

  const fetchData = async () => {
    if (!userId) return;
    
    try {
      setChartData(null); // Réinitialiser les données du graphique pendant le chargement
      console.log("Fetching data with dates:", { date, date2 });
      
      // Récupérer tous les tests de l'utilisateur
      const allTests = await getUserTestsAndCategories(userId);
      if (!allTests?.length) {
        console.log("No tests found");
        return;
      }
      
      console.log("Available tests:", allTests.map(t => t.testDate));
      
      // Trouver le test correspondant à la première date
      const test1 = allTests.find(t => t.testDate === date);
      if (!test1) {
        console.log("Test for date1 not found:", date);
        return;
      }
      
      // Extraire les questions du premier test
      const questions = test1.categories
        ?.flatMap(cat => cat.responses.map(r => ({ 
          question: r.question, 
          category: cat.category 
        }))) || [];
      
      // Fonction pour extraire les données d'un test
      const extractTestData = (test) => {
        if (!test || !test.categories) {
          console.log("Cannot extract data from test:", test?.testDate);
          return Array(labels.length).fill(null);
        }
        
        const data = [];
        
        // Parcourir les catégories dans l'ordre défini
        for (const categoryId of categoryIds) {
          const category = test.categories.find(cat => cat.category === categoryId);
          if (category && category.responses) {
            const responses = category.responses.map(r => r.response);
            data.push(...responses);
          } else {
            // Ajouter des valeurs nulles si la catégorie n'existe pas
            console.log(`Category ${categoryId} not found in test ${test.testDate}`);
          }
        }
        
        console.log(`Extracted ${data.length} data points for test ${test.testDate}`);
        return data;
      };
      
      // Extraire les données du premier test
      const data1 = extractTestData(test1);
      
      // Extraire les questions pour les tooltips
      const extractQuestions = (test) => {
        if (!test || !test.categories) return [];
        
        const questions = [];
        
        // Parcourir les catégories dans l'ordre défini
        for (const categoryId of categoryIds) {
          const category = test.categories.find(cat => cat.category === categoryId);
          if (category && category.responses) {
            const categoryQuestions = category.responses.map(r => r.question);
            questions.push(...categoryQuestions);
          }
        }
        
        return questions;
      };

      const extractedQuestions = extractQuestions(test1);
      
      // Créer l'objet de données de base avec le premier dataset
      const formattedData = {
        labels,
        datasets: [
          {
            label: formatISODate(test1.testDate),
            backgroundColor: "rgba(150, 50, 226, 0)",
            borderColor: "#ef5350",
            borderWidth: 2,
            pointBackgroundColor: "#424242",
            pointHoverBackgroundColor: "#424242",
            pointHoverBorderColor: "#424242",
            data: data1,
            LeaderShipAujourdhui: test1.LeaderShipAujourdhui || {},
            questions: extractedQuestions
          }
        ]
      };
      
      // Si une deuxième date est sélectionnée, ajouter un deuxième dataset
      if (date2) {
        console.log("Looking for test with date2:", date2);
        
        // Trouver le test correspondant à la deuxième date
        const test2 = allTests.find(t => t.testDate === date2);
        
        if (test2) {
          console.log("Found test2:", test2.testDate);
          
          // Extraire les données du deuxième test
          const data2 = extractTestData(test2);
          
          // Ajouter le deuxième dataset
          formattedData.datasets.push({
            label: formatISODate(test2.testDate),
            backgroundColor: "rgba(50, 150, 226, 0.1)",
            borderColor: "#0d47a1",
            borderWidth: 2,
            pointBackgroundColor: "#1E90FF",
            pointHoverBackgroundColor: "#1E90FF",
            pointHoverBorderColor: "#1E90FF",
            data: data2,
            LeaderShipAujourdhui: test2.LeaderShipAujourdhui || {}
          });
        } else {
          console.log("Test for date2 not found:", date2);
        }
      }
      
      console.log("Final formatted data:", formattedData);
      setChartData(formattedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getUserTestDates(userId);
  }, [userId]);

  useEffect(() => {
    fetchData();
  }, [userId, date, date2]);

  return {
    chartData,
    loading,
    testData,
    testDates,
    setDate,
    setDate2,
    date2,
    fetchData,
    testInfos,
  }; // Return testDates to use in other components
};

export default UseChartData;
